import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { Spin } from 'antd';

const LoanRepaymentListView = lazy(() => import('./views/LoanRepaymentListView'));

const LoadingFallback = () => (
  <div className="flex justify-center items-center h-full p-8">
    <Spin size="large" tip="Loading..." />
  </div>
);

export const loanRepaymentRoutes: RouteObject[] = [
  {
    path: '/loans/repayment',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanRepaymentListView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
];
